/* globals loader, SoundManager */

var SPINJS = window.SPINJS = window.SPINJS || {};

SPINJS.panel_base = '/spinjs/panel';

$.plugins.panel = {
	disabled: true,
	state: null,
	
	__init: function(config) {
		config.version = game.attr('data-version');
		
		/* Game Scaling */
		{
			game.on('scale', function(e) {
				var width  = e.detail.viewport.width;
				var height = e.detail.viewport.height;
				
				var size = e.detail.resize(game.panel.dimensions, game.panel, {
					width: width,
					height: height * game.panel.dimensions.height / game.panel.dimensions.screen_height,
				});
				
				game.panel.dialog.css('font-size', size.font + 'px');
				
				e.detail.resize(game.dimensions, game.container, {
					width: width,
					height: height * game.dimensions.height / game.dimensions.screen_height,
				});
				
				for (var key in game.features) {
					var dimensions = game.features[key].dimensions || game.dimensions;
					
					var factor = dimensions.full ? 1 : (game.dimensions.height / game.dimensions.screen_height);
					
					e.detail.resize(dimensions, game.features[key], {
						width: width,
						height: height * factor,
					});
				}
			});
			
			game.animationResize = function(animation) {
				animation.css('width', null);
				animation.css('width', animation.el.offsetWidth);
			};
			
			game.resetAnimationResize = function(animation) {
				animation.css('width', null);
			};
		}
		
		/* Button Sound */
		{
			this.on('click', function(e) {
				if (this.disabled) {
					return;
				}
				
				var el = e.target;
				
				if (game.panel.denom.el === el
				|| (game.panel.denom.label && game.panel.denom.label.el === el)
				|| (game.panel.denom.field && game.panel.denom.field.el === el)) {
					game.sounds.play([ 'buttons', 'denom' ]);
					
					return;
				}
			});
		}
		
		/* Auto-Close Menus */
		{
			var menus = this.menus = [];
			$(document).on('click', function(e) {
				loop: for (var m in menus) {
					var menu = menus[m].el;
					var parent = menus[m].el.parentNode;
					
					var el = e.target;
					
					do {
						if (menu === el || parent === el) {
							continue loop;
						}
					}
					while ((el = el.parentNode) && el && el.classList);
					
					menus[m].hide();
				}
			});
		}
		
		/* Currency Switch */
		{
			this.metersCash = [];
			this.metersCredits = [];
			this.isCash = false;
		}
		
		/* Dialog */
		{
			this.dialog = $.div('dialog').apply('dialog');

			if(config.version) {
				var version = config.version.split('-')[0];
				
				game.version = $.div('version').html('v' + version);
				game.version.appendTo(this.dialog.container);
			}
			
			this.dialog.pages.disconnect = $.div().addClass('noexit').html('<h2>Disconnected</h2><p>You have been disconnected from the server. Please refresh the game to continue. If the problem persists, please contact the operator.</p>');
			this.dialog.pages.fatal = $.div().addClass('noexit').html('<h2>Error</h2><p>An error has occured. Please refresh the game to continue. If the error persists, please contact the operator.</p>');
			this.dialog.pages.credits = $.div().html('<h2>Out Of Credits</h2><p>You do not have enough credits.</p>');
		}
		
		/* Recall */
		{
			var recall = game.recall = $.div('recall');
			$.element('h2').html('Game Recall').appendTo(recall);
			recall.table = $.element('table').appendTo(recall);
			$.element('p').html('Click a row to replay the game.').appendTo(recall);
			$.element('p').html('1 Credit = $0.01. *If applicable.').appendTo(recall);
			
			recall.show = function(list) {
				this.table.empty();
				
				var row = $.element('tr').appendTo(this.table);
				$.element('th').html('Date').appendTo(row);
				$.element('th').html('Beginning').appendTo(row);
				$.element('th').html('Bet').appendTo(row);
				$.element('th').html('Win').appendTo(row);
				$.element('th').html('Final').appendTo(row);
				
				for (var i = 0; i < list.length; i++) {
					var cycle = list[i];
					
					cycle.balance = $.plugins.meter.__format(cycle.balance);
					cycle.bet = $.plugins.meter.__format(cycle.bet);
					cycle.win = $.plugins.meter.__format(cycle.win);
					cycle.credits = $.plugins.meter.__format(cycle.credits);
					
					row = $.element('tr').appendTo(this.table);
					$.element('td').html(new Date(cycle.date).toLocaleString()).appendTo(row);
					$.element('td').html(cycle.balance).appendTo(row);
					$.element('td').html(cycle.bet).appendTo(row);
					$.element('td').html(cycle.win).appendTo(row);
					$.element('td').html(cycle.credits).appendTo(row);
					
					row.on('click', function(cycle) {
						var url = [ window.location.origin, window.location.pathname, '?cycleid=', cycle.id ].join('');
						window.open(url, 'recall-' + cycle.id);
					}.bind(null, cycle));
				}
				
				game.panel.dialog.show(recall);
			};
		}
		
		/* Sounds */
		{
			loader.start('sounds');
			
			game.sounds = new SoundManager({
				buttons: {
					auto: require('../sounds/buttons/auto.mp3'),
					denom: require('../sounds/buttons/denom.mp3'),
					help: require('../sounds/buttons/help.mp3'),
					lobby: require('../sounds/buttons/lobby.mp3'),
					max: require('../sounds/buttons/max.mp3'),
					menu: require('../sounds/buttons/menu.mp3'),
					recall: require('../sounds/buttons/recall.mp3'),
					sound: require('../sounds/buttons/sound.mp3'),
					spin: require('../sounds/buttons/spin.mp3'),
					play: require('../sounds/buttons/spin.mp3'),
					
					// Necessary style for fallback
					autos: {
						auto_0: require('../sounds/buttons/autos/auto_500.mp3'),
						auto_1: require('../sounds/buttons/autos/auto_250.mp3'),
						auto_2: require('../sounds/buttons/autos/auto_100.mp3'),
						auto_3: require('../sounds/buttons/autos/auto_50.mp3'),
						auto_4: require('../sounds/buttons/autos/auto_25.mp3'),
						auto_5: require('../sounds/buttons/autos/auto_10.mp3'),
						auto_6: require('../sounds/buttons/autos/auto_off.mp3'),
					},
					coins: {
						bet_0: require('../sounds/buttons/coins/bet_1.mp3'),
						bet_1: require('../sounds/buttons/coins/bet_2.mp3'),
						bet_2: require('../sounds/buttons/coins/bet_3.mp3'),
						bet_3: require('../sounds/buttons/coins/bet_4.mp3'),
						bet_4: require('../sounds/buttons/coins/bet_5.mp3'),
						bet_5: require('../sounds/buttons/coins/bet_6.mp3'),
					},
					denoms: {
						denom_0: require('../sounds/buttons/denoms/denom_01.mp3'),
						denom_1: require('../sounds/buttons/denoms/denom_05.mp3'),
						denom_2: require('../sounds/buttons/denoms/denom_10.mp3'),
						denom_3: require('../sounds/buttons/denoms/denom_25.mp3'),
						denom_4: require('../sounds/buttons/denoms/denom_50.mp3'),
						denom_5: require('../sounds/buttons/denoms/denom_100.mp3'),
						denom_6: require('../sounds/buttons/denoms/denom_500.mp3'),
					},
					lines: {
						line_0: require('../sounds/buttons/lines/line_1.mp3'),
						line_1: require('../sounds/buttons/lines/line_2.mp3'),
						line_2: require('../sounds/buttons/lines/line_3.mp3'),
						line_3: require('../sounds/buttons/lines/line_4.mp3'),
						line_4: require('../sounds/buttons/lines/line_5.mp3'),
						line_5: require('../sounds/buttons/lines/line_6.mp3'),
					},
				},
				win: {
					win_1: require('../sounds/win/win_1.mp3'),
					win_2: require('../sounds/win/win_2.mp3'),
					win_3: require('../sounds/win/win_3.mp3'),
				},
			}, window.sound_fallback || game.engine, function() { loader.stop('sounds'); });
		}
		
		/* Apply Full Panel */
		{
			if (Math.max(screen.width, screen.height) >= 1024) {
				this.dialog.addClass('desktop');
				this.apply('panel_desktop', config);
			}
			
			else {
				this.dialog.addClass('mobile');
				this.apply('panel_mobile', config);
			}
		}
		
		/* Wins */
		{
			this.bigwin = new SPINJS.BigWin(this);
		}
		
		this.disable(null);
	},
	
	setRecall: function() {
		game.panel.disable(true);
		game.inRecall = true;
		$.div('mode-recall').html('Recall Mode').appendTo(this);
	},
	
	registerMenu: function(menu) {
		this.menus.push(menu);
	},
	
	registerCash: function(meter, click) {
		this.metersCash.push(meter);
		
		meter.field.addClass('cash');
		
		if (click) {
			meter.on('click', function() {
				this.toggleCash();
			}.bind(this));
		}
	},
	
	registerCredits: function(meter, click) {
		this.metersCredits.push(meter);
		
		meter.field.addClass('cash');
		
		if (click) {
			meter.on('click', function() {
				this.toggleCash();
			}.bind(this));
		}
	},
	
	toggleCash: function(force) {
		if (typeof force === 'boolean') {
			this.isCash = !!force;
		}
		
		else {
			this.isCash = !this.isCash;
		}
		
		this.updateCash();
	},
	
	updateCash: function() {
		var denom = this.denom.get();
		
		for (var i = 0; i < this.metersCash.length; i++) {
			this.metersCash[i].scale(this.isCash ? 0 : denom);
			this.metersCash[i]._field.toggleClass('cash', this.isCash);
		}
		
		for (var i = 0; i < this.metersCredits.length; i++) {
			this.metersCredits[i].scale(this.isCash ? (1 / denom / 10) : 1);
			this.metersCredits[i]._field.toggleClass('cash', this.isCash);
		}
		
		this.emit('cash', denom);
	},
	
	enable: function() {
		this.disabled = false;
		this.removeClass('disabled');
		this.state = null;
	},
	
	disable: function(state) {
		this.disabled_last = this.disabled;
		this.state_last = this.state;
		
		this.disabled = true;
		this.addClass('disabled');
		
		if (typeof state !== 'undefined') {
			this.state = state;
		}
	},
	
	reable: function() {
		if (this.disabled_last) {
			this.disable(this.state_last);
		}
		
		else {
			this.enable();
		}
		
		game.emit('reable');
	},
	
	setBet: function(/* values */) {
		throw new Error('panel.setBet should be overridden.');
	},
	
	getBet: function() {
		throw new Error('panel.getBet should be overridden.');
	},
	
	setCredits: function(value) {
		this.credits.set(value);
	},
	
	incCredits: function(value) {
		this.credits.inc(value);
	},
	
	setWin: function(value, immediate) {
		if (immediate) {
			this.win.set(value, true);
			this.bigwin.stop(true);
			
			if (value === 0) {
				game.panel.bigwin.meter.field.css('font-size', ''); // reset big win meter value
				this.bigwin_reset = setTimeout(this.bigwin.meter.set.bind(this.bigwin.meter, value, true), 1000);
			}
			else {
				this.bigwin.meter.set(value, true);
			}
			
			return;
		}
		
		if (value === true) {
			this.win.update(true);
			this.bigwin.stop();
			
			return;
		}
		
		var track = null;
		
		if (typeof value === 'number') {
			var factor = value / (game.last._cost || game.old._cost);
			
			track = this.bigwin.play(factor);
		}
		
		clearTimeout(this.bigwin_reset);
		
		this.win.set(value, track);
		
		if(value >= 1000000 && value < 10000000) { // one hundred thousand to a million
			game.panel.bigwin.meter.field.css('font-size', '90%');
		}
		
		else if(value >= 10000000 && value < 1000000000 ) { // a million to one hundred million
			game.panel.bigwin.meter.field.css('font-size', '80%');
		}
		
		else if(value > 1000000000) { // assuming that it won't go much higher than that
			game.panel.bigwin.meter.field.css('font-size', '50%');
		}
		
		this.bigwin.meter.set(0, true);
		this.bigwin.meter.set(value, track);
		this.win.trigger('setWin', { value: value, immediate: track });
	},
	
	incWin: function(value, immediate) {
		this.win.inc(value, immediate);
	},
};



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/js/core.js
 **/